import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { STORE_HISTORY } from '../stores/constants';
import { HistoryStores } from '../stores';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { HistoryGrid } from '../components';

const HistoryPage: React.FC<HistoryStores> = ({ historyUI: store }) => {
    if (!store) {
        return null;
    }

    return (
        <HasPermission
            permissionClaim={AppPermissions.CanAccessAdministration}
            yes={() => <HistoryGrid store={store} />}
        />
    );
};

export default inject(STORE_HISTORY)(observer(HistoryPage));
